import React from 'react';
import PropTypes from 'prop-types';
import LocationCardFulfillmentMethod from 'components/Location/LocationCardFulfillmentMethod';
import LocationCardFulfillmentHours from 'bento-ordering/locations/components/LocationCardFulfillmentHours';
import { fulfillmentOptions } from 'constants/fulfillmentOptions';
import LocationCardFulfillmentTypeGridItem from 'components/Location/LocationCardFulfillmentTypeGridItem';
import { getFormattedDayOfWeek } from 'bento-ordering/base/utils/dates';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

export const NOT_ACCEPTING_ORDERS_INFORMATION_TEXT =
  'No online dine-in ordering is offered for this location';

/**
 * Renders available fulfillment options(CTA) and availability for dine-in ordering.
 *
 * @param isAcceptingDineInOrders
 * @param isAsapDineInCurrentlyAvailable
 * @param beginOrder
 * @param id
 * @param openDisplayDineInHours
 * @param firstAvailableDineInDateOption
 * @returns {*} React functional component
 * @constructor
 */
const LocationCardDineInFulfillmentMethods = ({
  isAcceptingDineInOrders,
  isAsapDineInCurrentlyAvailable,
  beginOrder,
  id,
  openDisplayDineInHours,
  firstAvailableDineInDateOption
}) => {
  return (
    <React.Fragment>
      {isAcceptingDineInOrders && (
        <LocationCardFulfillmentMethod
          isFullWidth
          buttonLabel={
            isAsapDineInCurrentlyAvailable ? 'Dine-In' : 'Dine-In Later'
          }
          handleButtonClick={() => beginOrder(fulfillmentOptions.DINE_IN)}
          disableButton={!isAsapDineInCurrentlyAvailable}
          hoursType={fulfillmentOptions.DINE_IN}
          buttonDataTestId={`location-${id}-dine-in-button`}
          LocationCardFulfillmentHours={
            <LocationCardFulfillmentHours
              hours={openDisplayDineInHours.today.hours}
              weekdayHours={openDisplayDineInHours.weekday_hours}
              hoursDataTestId={`location-${id}-dine-in-hours`}
              hoursLabel={
                isAsapDineInCurrentlyAvailable
                  ? "Today's Dine-In Hours"
                  : `Next Dine-In ${getFormattedDayOfWeek(
                      firstAvailableDineInDateOption
                    )}`
              }
            />
          }
        />
      )}
      {!isAcceptingDineInOrders && (
        <LocationCardFulfillmentTypeGridItem>
          <MenuItemDescriptionTypography variant={ITEM_DESCRIPTION_AND_PRICES}>
            {NOT_ACCEPTING_ORDERS_INFORMATION_TEXT}
          </MenuItemDescriptionTypography>
        </LocationCardFulfillmentTypeGridItem>
      )}
    </React.Fragment>
  );
};

LocationCardDineInFulfillmentMethods.propTypes = {
  beginOrder: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  firstAvailableDineInDateOption: PropTypes.string,
  isAcceptingDineInOrders: PropTypes.bool,
  isAsapDineInCurrentlyAvailable: PropTypes.bool,
  openDisplayDineInHours: PropTypes.shape({
    today: PropTypes.shape({
      hours: PropTypes.array
    }),
    weekday_hours: PropTypes.array
  })
};

LocationCardDineInFulfillmentMethods.defaultProps = {
  firstAvailableDineInDateOption: '',
  isAcceptingDineInOrders: true,
  isAsapDineInCurrentlyAvailable: true,
  openDisplayDineInHours: {}
};

export default LocationCardDineInFulfillmentMethods;
